import React, { useEffect, useState } from "react";
import StepAntecedentes from "./StepAntecedentes";
import StepPlanes from "./StepPlanes";
import StepResumen from "./StepResumen";
import rutValidator from '../../utils/validateRut';
import {getPlanesActivosOnBoard} from "../../services/Planes";
import {getComunasOnBoard} from "../../services/Comunas";
import { getClientesRutOnBoard,getClientesEmailOnBoard, onBoardCliente } from "../../services/Clientes";
import { Toaster,toast } from 'react-hot-toast';
import StepperOnboarding from "./StepperOnboarding";
import { useNavigate } from "react-router-dom";

const Onboarding = () => {
  const [step, setStep] = useState(0);
  const [comunas, setComunas] = useState([]);
  const [planes, setPlanes] = useState([]);
  const [planesSeleccionados, setPlanesSeleccionados] = useState([]);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    rut: "",
    nombre: "",
    telefono: "",
    email: "",
    direccion: "",
    numero:"",
    idComuna: "",
    nombreComuna: "",
    nombreCiudad: "",
  });

  const [errores, setErrores] = useState({});

  const pasos = ["Antecedentes", "Planes", "Resumen"];

  useEffect(() => {
    const cargarDatos = async () => {
      const [comunasData, planesData] = await Promise.all([
        getComunasOnBoard(),
        getPlanesActivosOnBoard(),
      ]);

      setComunas(comunasData || []);
      setPlanes(planesData || []);
      setPlanesSeleccionados([]);
    };
    cargarDatos();
  }, []);

  const validarPasoActual = () => {
  if (step === 0) {
    const nuevosErrores = {};
    if (!formData.rut) nuevosErrores.rut = "El RUT es obligatorio";
    if( !rutValidator(formData.rut)) nuevosErrores.rut = "RUT Ingresado no es Válido!";
    if (!formData.nombre) nuevosErrores.nombre = "El nombre es obligatorio";
    if (!formData.telefono) nuevosErrores.telefono = "El teléfono es obligatorio";
    if (!formData.email) nuevosErrores.email = "El email es obligatorio";
    if (!formData.idComuna) nuevosErrores.comuna = "La comuna es obligatoria";
    if (!formData.direccion) nuevosErrores.direccion = "La dirección es obligatoria";
    if (!formData.numero) nuevosErrores.numero = "El número es obligatoria";

    setErrores(nuevosErrores);
    console.log("Errores paso 0:", nuevosErrores); // 👈 este log
    return Object.keys(nuevosErrores).length === 0;
  }

  if (step === 1) {
    const grupo1 = planes.filter(p => p.tipoPlan === "Retiro" && planesSeleccionados.includes(p._id));
    const grupo2 = planes.filter(p => p.tipoPlan !== "Retiro" && planesSeleccionados.includes(p._id));
    
    if (grupo1.length === 0 && grupo2.length === 0) {
      console.log("Errores en paso 1:"); // 👈 este log
      toast.error("Debe seleccionar al menos un plan de Retiro o Entrega en Punto Drop off");
      return false;
    }
  }

  return true;
};

  const siguientePaso = () => {
    if (validarPasoActual()) setStep((prev) => prev + 1);
  };

  const pasoAnterior = () => setStep((prev) => prev - 1);

  const cancelar = () => {
      setFormData({
        rut: "",
        nombre: "",
        telefono: "",
        email: "",
        direccion: "",
        numero:"",
        idComuna: "",
        nombreComuna: ""
      });
      toast.error("Proceso de registro cancelado");
      navigate("/login");

  };

  const finalizar = async () => {
    try {
        console.log("Finalizando registro con datos:", formData, planesSeleccionados);
        const clienteExistente = await getClientesRutOnBoard(formData.rut)
        if (clienteExistente.length > 0) {
          console.log("Cliente ya existe:", clienteExistente);
          toast.error("El cliente ya existe, por favor verifique el RUT ingresado");
          return;
        }

        const emailExistente = await getClientesEmailOnBoard(formData.email)
        if (emailExistente.length > 0) {
          console.log("Correo electrónico ya existe:", clienteExistente);
          toast.error("El correo electrónico ya existe, por favor corregir");
          return;
        }


        let miLon = -70.6693;
        let miLat = -33.4489;
        try {
            const query = `${formData.direccion} ${formData.numero}, ${formData.nombreComuna}, ${formData.nombreCiudad}`;
              const response = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`
              );
              
              const data = await response.json();
              
              if (data.length === 0) {
                console.log('Dirección no encontrada');
              } else{
                let { lat, lon } = data[0];
                miLon = parseFloat(lon);
                miLat = parseFloat(lat);
                console.log('Coordenadas obtenidas:', miLat, miLon);
              }
        } catch (error) {
              console.log('Error al geocodificar la dirección:', error); 
        }

        const dataOnBoard = {
          empresa: '67fb199c799c1b69ec40fa38',
          rut: formData.rut,
          nombre: formData.nombre,
          direccion: formData.direccion,
          numero: formData.numero,
          telefono: formData.telefono,
          email: formData.email,
          lat: miLat,
          lng: miLon,
          idComuna: formData.idComuna,
          planes: planesSeleccionados,
        };

         await onBoardCliente( dataOnBoard );

          toast.success("Gracias por ser miembro de la comunidad BioMap, hemos habilitado su acceso, hemos enviado un correo electrónico a su cuenta con las indicaciones para acceder.");

         navigate("/login");
/*
          toast.custom((t) => (
            <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-w-full">
              <h3 className="text-lg font-semibold">Gracias por ser miembro de BioMap, hemos habilitado su acceso, para acceder ingrese su correo electrónico como usuario y se le asigno una password temporal biomap.2025 que debe cambiar una vez ingrese.</h3>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-red-500 text-white rounded"
                  onClick={() => {
                    navigate("/login");
                    toast.dismiss(t.id);
                  }}
                >
                  Volver
                </button>
              </div>
            </div>
          ));
*/

        
        // Aquí se enviaría a la API
    } catch (error) {
      console.log("Problemas , contacte a soporte" + error);
      toast.error("Error al Inicializar Plan, contacte a soporte");
    }


  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">Registro de Cliente</h2>

      <StepperOnboarding step={step} />

      <div className="bg-white shadow p-4 rounded-xl">
        {step === 0 && (
          <StepAntecedentes formData={formData} setFormData={setFormData} comunas={comunas} errores={errores} />
        )}
        {step === 1 && (
          <StepPlanes planes={planes} planesSeleccionados={planesSeleccionados} setPlanesSeleccionados={setPlanesSeleccionados} />
        )}
        {step === 2 && (
          <StepResumen formData={formData} planesSeleccionados={planesSeleccionados} planes={planes} />
        )}
      </div>

      <div className="flex justify-between mt-6">
        <button type="button" onClick={cancelar} className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300">Cancelar</button>
        <div className="space-x-2">
          {step > 0 && (
            <button onClick={pasoAnterior} type="button" className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400">Anterior</button>
          )}
          {step < pasos.length - 1 ? (
            <button onClick={siguientePaso} type="button" className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700">Siguiente</button>
          ) : (
            <button onClick={finalizar} type="button" className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">Finalizar</button>
          )}
        </div>
      </div>
      <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />               
    </div>
  );
};

export default Onboarding;
